import { createFileRoute } from '@tanstack/react-router';

import { HiringOpeningPage } from '@/features/hiring/opening-page';

export const Route = createFileRoute('/_app/projects/$projectId/hiring/openings/$openingId')({
  component: PageRoute,
});

function PageRoute() {
  const { projectId, openingId } = Route.useParams();
  return <HiringOpeningPage projectId={projectId} openingId={openingId} />;
}
